import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {BuyboxSuppressedItem} from './dashboardTableTypes'
import {renderDashboardDateTwoLine, renderDashboardSku, renderDashboardSellerNameWithId, renderDashboardLinkIcon} from './dashboardFormatters'

const columns: DashboardColumn<BuyboxSuppressedItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  // {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
  {
    header: 'Product Status',
    sortKey: 'product_status',
    render: (item) =>
      item.product_status ? (
        <span className='d-inline-flex align-items-center rounded-pill px-3 py-1 fs-7 fw-bold bg-light text-gray-700'>
          {item.no_buybox_available ? 'SUPPRESSED' : 'BUYBOX NOT FEATURED'}
        </span>
      ) : (
        '-'
      ),
  },
  {header: 'Product Colour', sortKey: 'color', render: (item) => item.color ?? '-'},
  // {header: 'Quantity', sortKey: 'quantity', render: (item) => item.quantity ?? '-'},
  {header: 'Our Seller Id', sortKey: 'our_seller_id', render: (item) => renderDashboardSellerNameWithId(item.our_seller_name, item.our_seller_id)},
  {header: 'Winner Seller Id', sortKey: 'buybox_winner_seller_id', render: (item) => renderDashboardSellerNameWithId(item.buybox_winner_seller_name, item.buybox_winner_seller_id)},
  {header: 'Scraped At', sortKey: 'scraped_timestamp', width: 160, render: (item) => renderDashboardDateTwoLine(item.scraped_timestamp)},
  {header: 'Product Link', render: (item) => renderDashboardLinkIcon(item.product_link)},
]

function BuyboxSuppressedShow() {
  return (
    <DashboardApiTableShow<BuyboxSuppressedItem>
      endpoint='BuyboxSuppressed'
      title='BuyBox Suppressed'
      columns={columns}
    />
  )
}

export default BuyboxSuppressedShow
